import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import analyticsTrack from '@lib/analytics/analyticsTrack';
import { getResizedImageUrl } from '@lib/image';
import breakpoints from '@constants/breakpoints';
import styles from './ExploreByStyle.module.scss';
import { IExploreTile } from './ExploreByStyle.data';

const TILE_RESIZE_WIDTH = 460; // 2x of ~230px tile for retina

// Prismic images include their own resize query params; skip Thumbor for those.
function tileImageSrc(imageUrl: string): string {
  if (imageUrl.includes('prismic.io')) return imageUrl;
  return getResizedImageUrl({
    url: imageUrl,
    width: TILE_RESIZE_WIDTH,
    height: TILE_RESIZE_WIDTH,
    quality: 80,
  });
}

interface IExploreByStyleRowProps {
  title: string;
  tiles: IExploreTile[];
  trackingRow: 'style' | 'room';
}

export default function ExploreByStyleRow({
  title,
  tiles,
  trackingRow,
}: IExploreByStyleRowProps) {
  return (
    <div className={styles.Row}>
      <h3 className={styles.RowTitle}>{title}</h3>
      <div className={styles.Divider} />
      <Swiper
        slidesPerView="auto"
        spaceBetween={12}
        grabCursor
        className={styles.Swiper}
        breakpoints={{
          [breakpoints.desktop]: {
            spaceBetween: 15,
          },
        }}
      >
        {tiles.map((tile) => (
          <SwiperSlide key={tile.url} className={styles.Slide}>
            <a
              className={styles.Tile}
              href={tile.url}
              draggable={false}
              onClick={() => {
                analyticsTrack('home_explore_tile_click', {
                  row: trackingRow,
                  title: tile.title,
                  url: tile.url,
                });
              }}
            >
              <div className={styles.TileImageWrap}>
                <img
                  src={tileImageSrc(tile.imageUrl)}
                  alt={tile.imageAlt}
                  className={styles.TileImage}
                  loading="lazy"
                  draggable={false}
                />
              </div>
              <p className={styles.TileLabel}>{tile.title}</p>
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
